import { createContext } from 'react';
const ObjectHistoryContext = createContext({
    objectHistoryFilter: undefined,
    objectHistory: undefined,
});
export { ObjectHistoryContext };
